import { render, staticRenderFns } from "./AddChildMemberModal.vue?vue&type=template&id=317c8085"
import script from "./AddChildMemberModal.vue?vue&type=script&lang=ts"
export * from "./AddChildMemberModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports